
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-club",
      function () {
        return require("private-next-pages/the-club.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-club"])
      });
    }
  